import React, { useEffect, useMemo, useState } from 'react'
import {
  EnvironmentContainer,
  EnvironmentTitle,
  HeaderWarper,
  StyleLogoutIcon,
  StyleMenuItem,
  Title,
  UserIcon
} from './Header.style'
import { useNavigate } from 'react-router-dom'
import { Box, IconButton, Menu, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { userLogout } from '../../redux/slices/Auth/AuthSlice'
import DailyPnl from './components/DailyPnl/DailyPnl'
import { routes } from '../../utils/constants'
import { setWidgets } from '../../redux/slices/widgets/WidgetsSlice'
import axios from 'axios'
import { webSocketWorkerEvent } from '../../services'
import WidgetsOption from './components/WidgetsOption/WidgetsOption'
import UserPermissionView from './components/UserPermissionView/UserPermissionView'
import { getCountryTimezoneUtc } from '../../helper'

const Header = () => {
  const token = useSelector(state => state.auth.token)
  const title = useSelector(state => state.auth.title)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const items = useMemo(() => ['Activity Blotter', 'Rates'], [])
  const views = useMemo(() => ['Default', 'EFX'], [])
  const [menuOpen, setMenuOpen] = useState(false)
  const [checkedItems, setCheckedItems] = useState([])
  const widgets = useSelector(state => state.widgets.widgets)

  useEffect(() => {
    webSocketWorkerEvent.sendEvent({
      type: 'get_daily_pnl',
      data: { country_timezone_utc: getCountryTimezoneUtc() }
    })
  }, [])

  const handelClick = () => {
    setOpen(!open)
  }

  const handelLogout = () => {
    dispatch(userLogout(navigate))
  }

  const handelMenuClick = () => {
    setMenuOpen(true)
  }

  const handleToggle = value => () => {
    const currentIndex = checkedItems.indexOf(value)
    const newChecked = [...checkedItems]
    if (currentIndex === -1) {
      addWidgetToUserPreference(value)
      newChecked.push(value)
    } else {
      removeWidgetToUserPreference(value)
      newChecked.splice(currentIndex, 1)
    }

    setCheckedItems(newChecked)
  }

  const handleClose = () => {
    setMenuOpen(false)
  }

  const addWidgetToUserPreference = async val => {
    try {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.addWidget, '/')
      const result = await axios.post(url, { val }, { headers: { Authorization: token } })
      if (val === 'Activity Blotter') {
        webSocketWorkerEvent.sendEvent({
          type: 'get_activity_blotter',
          data: {
            country_timezone_utc: getCountryTimezoneUtc()
          }
        })
      }
      result.data = result.data.map(({ preferences }) => preferences)
      dispatch(setWidgets(result.data))
    } catch (error) {
      console.log(error)
    }
  }

  const removeWidgetToUserPreference = async val => {
    try {
      const url = process.env.REACT_APP_SERVER_URL.concat(routes.removeWidget, '/')
      const result = await axios.post(url, { val }, { headers: { Authorization: token } })
      if (val === 'Activity Blotter') {
        webSocketWorkerEvent.sendEvent({ type: 'remove_activity_blotter', data: {} })
      }
      result.data = result.data.map(({ preferences }) => preferences)
      dispatch(setWidgets(result.data))
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (widgets && widgets.length > 0) {
      setCheckedItems(widgets)
    } else {
      setCheckedItems([])
    }
  }, [widgets])

  return (
    <HeaderWarper id="header">
      <Title>{title}</Title>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        {window.location.href.includes('dev') && (
          <EnvironmentContainer>
            <EnvironmentTitle>DEV</EnvironmentTitle>
          </EnvironmentContainer>
        )}

        <Box
          style={{
            display: 'flex',
            gap: '16px',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <Box>
            <UserPermissionView views={views} />
            <WidgetsOption
              menuOpen={menuOpen}
              open={open}
              checkedItems={checkedItems}
              items={items}
              handleToggle={handleToggle}
              handelMenuClick={handelMenuClick}
              handleClose={handleClose}
            />
          </Box>
          <DailyPnl />
          <IconButton
            onClick={handelClick}
            size="small"
            sx={{ ml: 0 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
          >
            <UserIcon />
          </IconButton>
          <Menu
            open={open}
            onClose={handelClick}
            onClick={handelClick}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  borderRadius: '4px !important',
                  backgroundColor: '#39393C',
                  marginTop: '40px',
                  top: '20px !important',
                  padding: '0px',
                  '&::before': {
                    display: 'block',
                    position: 'absolute'
                  },
                  '& .MuiList-root': {
                    borderRadius: '4px !important',
                    padding: '8px 24px'
                  }
                }
              }
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
          >
            <StyleMenuItem onClick={handelLogout}>
              <StyleLogoutIcon />
              <Typography style={{ color: 'white', marginLeft: '12px', fontSize: '14px' }}>
                Log out
              </Typography>
            </StyleMenuItem>
          </Menu>
        </Box>
      </Box>
    </HeaderWarper>
  )
}

export default Header
